import { call, put } from 'redux-saga/effects';
import {
  getReceiptStatisticsForEntity,
  GetReceiptStatisticsResponse,
} from '../api';
import {
  fetchReceiptStatisticsEntityFailure,
  fetchReceiptStatisticsEntitySuccess,
} from '../actions';
import { FetchReceiptStatisticsEntityRequestAction } from '../types';
import { ApiError } from 'store/api/types';
import { checkResponse } from 'store/utils';
import { MessageData } from 'store/app/types';
import { turnMessageOn } from 'store/app/actions';
import { logoutRequest } from 'store/auth/actions';
import { renderErrorMessage } from 'utils/render-error-message';
import {
  emptyReceiptStatisticsTotals,
  receiptStatisticsEntityCacheKey,
  unwrapReceiptStatisticsPayload,
} from 'utils/receipt-statistics';

export function* fetchReceiptStatisticsEntitySaga(
  action: FetchReceiptStatisticsEntityRequestAction
) {
  try {
    const { connectionId, from, to } = action.payload;
    const dateRange = { from, to };
    const cacheKey = receiptStatisticsEntityCacheKey(connectionId, dateRange);

    const response: GetReceiptStatisticsResponse = yield call(
      getReceiptStatisticsForEntity,
      connectionId,
      dateRange
    );

    const err: ApiError | null = checkResponse(response?.responseMessage);
    if (err) throw err;

    const payload = unwrapReceiptStatisticsPayload(
      response?.data as Record<string, unknown>
    );
    const statistics = payload
      ? {
          uploadedFilesTotal: payload.uploadedFilesTotal ?? 0,
          activeFiles: payload.activeFiles ?? 0,
          filesWithErrors: payload.filesWithErrors ?? 0,
          deletedFiles: payload.deletedFiles ?? 0,
          uploadedManually: payload.uploadedManually ?? 0,
          uploadedFromGoogleDrive: payload.uploadedFromGoogleDrive ?? 0,
          uploadedFromOneDrive: payload.uploadedFromOneDrive ?? 0,
          uploadedFromEmail: payload.uploadedFromEmail ?? 0,
          uploadedThisMonth: payload.uploadedThisMonth ?? 0,
          postedFiles: payload.postedFiles ?? 0,
          postedThisMonth: payload.postedThisMonth ?? 0,
          filesPendingReview: payload.filesPendingReview ?? 0,
          filesReviewed: payload.filesReviewed ?? 0,
          transactionsPendingReview: payload.transactionsPendingReview ?? 0,
          reviewedTransactions: payload.reviewedTransactions ?? 0,
        }
      : emptyReceiptStatisticsTotals();

    yield put(fetchReceiptStatisticsEntitySuccess(cacheKey, statistics));
  } catch (error: any) {
    const message: MessageData | null = renderErrorMessage(error);
    if (message) {
      yield put(turnMessageOn(message));
    } else {
      yield put(logoutRequest());
    }
    yield put(fetchReceiptStatisticsEntityFailure());
  }
}
